import * as i0 from "@angular/core";
export class EnvironmentService {
    constructor() {
        this.env = 'pro';
        switch (this.env) {
            case 'pro':
                this.cmsServerURL = 'https://worldarchery.sport';
                break;
            case 'stg':
                this.cmsServerURL = 'https://tests.worldarchery.sport';
                break;
            case 'dev':
                this.cmsServerURL = 'http://worldarchery.me';
        }
        // API server it's always the same.
        this.waApiServerURL = 'https://api.worldarchery.sport';
    }
    getWAServerURL() {
        return this.cmsServerURL;
    }
    isDev() {
        return this.env === 'dev';
    }
    getEnv() {
        return this.env;
    }
}
EnvironmentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EnvironmentService_Factory() { return new EnvironmentService(); }, token: EnvironmentService, providedIn: "root" });
